import { z } from "zod"

const targetTypeSchema = z.enum(["post", "user_note"])
export type TagTargetType = z.infer<typeof targetTypeSchema>

export function createTagsId(targetType: TagTargetType, targetId: string) {
  return `${targetType}:${targetId}`
}
